import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { TranslationsKeys } from '../../../../../locales/translations';

const prefix = 'form.create';

export function useTexts() {
  const { t } = useTranslation(TranslationsKeys.STUDENT_FILE_OBSERVATIONS);
  return useMemo(
    () => ({
      modal: {
        title: t(`${prefix}.modal.title`),
        titleSee: t(`${prefix}.modal.titleSee`),
        inputs: {
          course: {
            label: t(`${prefix}.modal.form.course.label`),
            placeholder: t(`${prefix}.modal.form.course.placeholder`),
          },
          type: {
            label: t(`${prefix}.modal.form.type.label`),
            placeholder: t(`${prefix}.modal.form.type.placeholder`),
          },
          observation: {
            label: t(`${prefix}.modal.form.observation.label`),
            placeholder: t(`${prefix}.modal.form.observation.placeholder`),
          },
          file: {
            label: t(`${prefix}.modal.form.file.label`),
            btnReplace: t(`${prefix}.modal.form.file.btnReplace`),
            btn: t(`${prefix}.modal.form.file.btn`),
          },
        },
        buttons: {
          close: t(`${prefix}.modal.buttons.close`),
          cancel: t(`${prefix}.modal.buttons.cancel`),
          create: t(`${prefix}.modal.buttons.create`),
        },
        success: t(`${prefix}.success`),
        error: t(`${prefix}.error`),
      },
      toast: {
        success: t(`${prefix}.toast.success`),
        error: t(`${prefix}.toast.error`),
      },
    }),
    [t],
  );
}
